import { FileText, Eye, Download } from 'lucide-react';
import { useProfile } from '../../../../../context/profile/ProfileContext';

const SubscriptionPaymentHistoryTable = () => {
  const {
    subscription,
    paymentHistory,
    handleViewInvoice,
    handleDownloadInvoice,
    formatDate,
    formatCurrency
  } = useProfile();

  return (
    <section className="bg-white rounded-2xl sm:rounded-3xl border border-gray-100 p-4 sm:p-6 lg:p-7 shadow-sm mt-6">
      <div className="border-b border-slate-100 pb-3.5 sm:pb-4 mb-3.5 sm:mb-4 flex flex-col sm:flex-row justify-between sm:items-center gap-1">
        <div>
          <h2 className="font-semibold text-slate-900 text-sm sm:text-base">Invoices &amp; billing history</h2>
          <p className="text-xs text-slate-500 mt-0.5 font-normal">Download official tax invoices with GST breakdown</p>
        </div>
      </div>

      {paymentHistory && paymentHistory.length > 0 ? (
        <div className="overflow-x-auto -mx-4 sm:mx-0 px-4 sm:px-0">
          <table className="w-full text-left text-xs border-collapse min-w-[540px]">
            <thead>
              <tr className="border-b border-slate-100 text-slate-500 font-semibold uppercase text-[10px] tracking-wider">
                <th className="py-3 px-3">Date</th>
                <th className="py-3 px-3">Plan / Description</th>
                <th className="py-3 px-3">Amount</th>
                <th className="py-3 px-3">Status</th>
                <th className="py-3 px-3 text-right">Invoice</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100 text-slate-700">
              {paymentHistory.map((pm, index) => {
                const isSuccess = pm.status === 'captured' || pm.status === 'active' || pm.status === 'success';
                return (
                  <tr key={pm._id || pm.payment_id || index} className="hover:bg-slate-50/60 transition-colors">
                    <td className="py-3.5 px-3 font-medium whitespace-nowrap">
                      {formatDate(pm.created_at || pm.createdAt)}
                    </td>
                    <td className="py-3.5 px-3">
                      <span className="font-semibold text-slate-800 block">
                        {pm.plan_name || subscription?.plan_id?.name || 'Pro Plan'}
                      </span>
                      <span className="text-[11px] text-slate-400">
                        {pm.billing_interval === 'year' ? 'Annual renewal' : pm.billing_interval === '6months' ? '6 Months renewal' : 'Monthly renewal'}
                      </span>
                    </td>
                    <td className="py-3.5 px-3 font-semibold text-slate-900 whitespace-nowrap">
                      {formatCurrency(pm.amount || pm.base_amount || 0)}
                      {pm.gst_amount > 0 && (
                        <span className="text-[10px] text-slate-400 font-normal block">
                          incl. ₹{pm.gst_amount} GST
                        </span>
                      )}
                    </td>
                    <td className="py-3.5 px-3">
                      <span className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[10px] font-semibold capitalize ${
                        isSuccess ? 'bg-emerald-50 text-emerald-700' : 'bg-rose-50 text-rose-700'
                      }`}>
                        <span className={`w-1.5 h-1.5 rounded-full ${isSuccess ? 'bg-emerald-500' : 'bg-rose-500'}`}></span>
                        {pm.status || 'Paid'}
                      </span>
                    </td>
                    <td className="py-3.5 px-3 text-right whitespace-nowrap">
                      <div className="inline-flex items-center gap-2 justify-end">
                        <button
                          type="button"
                          onClick={() => handleViewInvoice(pm)}
                          className="p-1.5 text-slate-600 hover:text-[#067978] hover:bg-slate-100 rounded-lg transition-all cursor-pointer"
                          title="View Invoice"
                        >
                          <Eye size={15} />
                        </button>
                        <button
                          type="button"
                          onClick={() => handleDownloadInvoice(pm)}
                          className="p-1.5 text-slate-600 hover:text-[#067978] hover:bg-slate-100 rounded-lg transition-all cursor-pointer"
                          title="Download PDF"
                        >
                          <Download size={15} />
                        </button>
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      ) : (
        <div className="text-center py-8 bg-slate-50 rounded-xl border border-dashed border-slate-200">
          <FileText size={24} className="text-slate-350 mx-auto mb-2" />
          <h4 className="text-xs font-bold text-slate-700">No Billing History</h4>
          <p className="text-[11px] text-slate-400 mt-0.5">Your invoices will display here once transactions begin.</p>
        </div>
      )}
    </section>
  );
};

export default SubscriptionPaymentHistoryTable;
